import {Validation, type ValidationConfig, type ValidationResponse, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";
import type {UploadData} from "../components/formUploadField";

export type FileCountConfig = ValidationConfig & {
    id: "maxUploads";
    maxUploads: number;
};

export class MaxUploads extends Validation {
    private constructor(messageText: string, onlyWarning: WarningLevel, private maxUploads: number) {
        super(messageText, onlyWarning);
    }

    public static from(config: FileCountConfig): MaxUploads {
        return new MaxUploads(config.message, config.warningLevel, config.maxUploads);
    }

    protected valid(files: UploadData[]): boolean {
        return !files || files.length <= this.maxUploads;
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value?: T): void {
        const validationResponse: ValidationResponse = this.checkValidity(value);

        if (!validationResponse.valid) {
            inputElement.addMessage({warningLevel: validationResponse.warningLevel, message: this.errorText});
        }
    }
}